import gql from 'graphql-tag';

// Query for cappex fields based on query string
// Used for Appily Auth
export const APPILY_QUERY  = gql`
  query ($instId: String!, $locId: String!) {
    institutions(instID: $instId) {
      cx_inst_id
    }
    locations(locID: $locId) {
      cx_flex_reg_id
    }
  }
`;
